import React from 'react';
import { Route, Switch } from 'react-router-dom';
import WebhooksPage from '../../pages/integracao/webhooks/WebhooksPage';

export default () => (
  <Switch>
    <Route exact path="/intranet/integracao/webhooks" component={WebhooksPage} />
  </Switch>
);
